var map = {
	"./logo-tl-dark.svg": "./src/assets/img/logo-tl-dark.svg",
	"./logo-tl-light.svg": "./src/assets/img/logo-tl-light.svg",
	"./logo-tl-mobil-dark.svg": "./src/assets/img/logo-tl-mobil-dark.svg",
	"./logo-tl-mobil-light.svg": "./src/assets/img/logo-tl-mobil-light.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/logo\\-tl.*\\.svg$";